import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";

const lesson: Lesson = {
  id: "06ee648f-a0fa-4c9b-9010-720d360880e1",
  publicId: "32",
  name: "Psychoacoustical listening experiment examining our ability to localize sound sources",
  showHeaderNavigation: true,
  body: [principle01, principle02],
};

export default lesson;
